<template>
  <v-card
    style="
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
    "
    variant="outlined"
    class="mb-2 px-2">
    <h2 class="my-0">{{ name }}</h2>
    <v-progress-circular
      v-if="!textonly"
      class="mx-2"
      rotate="90"
      size="105"
      width="30"
      style="display: flex; align-items: center"
      :value="percent"
      :color="percent >= 94 ? 'orange' : '#5d6ae3'">
      <h2 class="ma-0">{{ Math.round(percent) }}%</h2>
    </v-progress-circular>
    <h2
      v-else
      class="ma-0">
      {{ percent }}
    </h2>
  </v-card>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps(['percent', 'name', 'textonly']);
</script>
